import React from 'react';
import Panel from '../../components/atom/Panel';
import WeatherIcon from '../../components/atom/WeatherIcon';
import './ForecastBadge.css';

const ForecastBadge = ({ data }) => {
    //data : const forecastFirstDay = {
    //      dateDay: "Monday",
    //      weatherDay: "sunny",
    //      temperatureDay: 18,
    //      weatherNight: "clear",
    //      temperatureNight: 10


  return (
    <Panel className="forecastBadge-panel">
        <div className="forecastBadge-head">
            <div>{data.dateDay}</div>
        </div>
        <div className="forecastBadge-content">
            <div className="forecastDay">
                
                    <WeatherIcon type={"sunny"}  className="small-weatherIcon"/>
                    <div className="forecastContainer">
                    <WeatherIcon type={data.weatherDay} className="big-weatherIcon"/>
                    <div className="forecastBadge-temp">{data.temperatureDay}°</div>
                    </div>
                
            </div>
            <div className="forecastNight">
                
                    <WeatherIcon type={"waxingCrescentMoon"} className="small-weatherIcon" />
                    <div className="forecastContainer">
                    <WeatherIcon type={data.weatherNight} className="big-weatherIcon" />
                    <div className="forecastBadge-temp">{data.temperatureNight}°</div>
                    </div>
                
            </div>

      </div>
    </Panel>
  );
};

export default ForecastBadge;
